import React from 'react';
import { useNavigate } from 'react-router-dom';
import { User } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

const ConsoleLayout = ({ pillarLabel, children, showBottomNav = false }) => {
  const navigate = useNavigate();
  const { user, getHomePage } = useAuth();

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      {/* Top App Bar - Sticky */}
      <header className="sticky top-0 z-50 bg-white border-b border-gray-200 shadow-sm">
        <div className="h-14 px-4 flex items-center justify-between">
          {/* Logo */}
          <div 
            className="cursor-pointer"
            onClick={() => navigate(getHomePage(user))}
          >
            <img 
              src="/newaudia-logo.jpg" 
              alt="NewAudia" 
              className="h-16 w-auto object-contain"
            />
          </div>
          
          {/* Pillar Label */}
          <h1 className="text-lg font-semibold text-gray-800">{pillarLabel}</h1>
          
          {/* Avatar Placeholder */}
          <div className="w-8 h-8 bg-purple-600 rounded-full flex items-center justify-center">
            <User className="w-5 h-5 text-white" />
          </div>
        </div>
      </header>

      {/* Main Content - Scrollable */}
      <main className="flex-1 overflow-y-auto pb-20">
        {children}
      </main>

      {/* Optional Bottom Mini-Nav */}
      {showBottomNav && (
        <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 h-16 flex items-center justify-around z-50 lg:hidden">
          <button className="flex flex-col items-center gap-1 text-purple-600">
            <div className="w-6 h-6 rounded-full bg-purple-100"></div>
            <span className="text-xs font-medium">Home</span>
          </button>
          <button className="flex flex-col items-center gap-1 text-gray-400">
            <div className="w-6 h-6 rounded-full bg-gray-100"></div>
            <span className="text-xs font-medium">Library</span>
          </button>
          <button className="flex flex-col items-center gap-1 text-gray-400">
            <div className="w-6 h-6 rounded-full bg-gray-100"></div>
            <span className="text-xs font-medium">Profile</span>
          </button>
        </nav>
      )}
    </div>
  );
};

export default ConsoleLayout;
